import { useState, useCallback } from 'react';
import { mockUser, topicCategories, mockPartners } from '../data/mockData';

export function useAppStore() {
  const [user] = useState(mockUser);
  const [topics, setTopics] = useState(topicCategories);
  const [partners] = useState(mockPartners);

  const updateAnswer = useCallback((topicId, questionId, value) => {
    setTopics(prev => prev.map(t =>
      t.id === topicId ? { ...t, answers: { ...t.answers, [questionId]: value } } : t
    ));
  }, []);

  const markComplete = useCallback((topicId) => {
    setTopics(prev => prev.map(t =>
      t.id === topicId ? { ...t, completed: true } : t
    ));
  }, []);

  const completedCount = topics.filter(t => t.completed).length;

  return { user, topics, partners, updateAnswer, markComplete, completedCount };
}
